import { Outlet } from "react-router-dom";
import globalStyles from "../../assets/styles/base/globalPage.module.scss";

export const AllSectionsLayout = () => {
  return (
    <div className={globalStyles.pagePaddings}>
      <Outlet />
    </div>
  );
};
